import { useLocation, useNavigate } from "react-router-dom";
import { ReuseButton } from "../ui";
import { ButtonsType } from "../../types/enums";

export const ResetAllFiltersButton = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const resetAllFilters = () => {
    const searchParams = new URLSearchParams(search);

    [
      "industries",
      "regions",
      "sizes",
      "date",
      "trend",
      "status_filter",
      "buyer_journey",
      "roles",
      "data_source",
      "personas",
    ].forEach((query) => searchParams.delete(query));

    const newQuery = searchParams.toString();
    const queryString = newQuery ? `?${newQuery}` : "";
    navigate(`${pathname}${queryString}`, { replace: true });
  };

  return (
    <ReuseButton
      onClick={resetAllFilters}
      buttonType={ButtonsType.text}
      style={{
        textDecoration: "underline",
      }}
    >
      Reset All
    </ReuseButton>
  );
};
